// borrowed from:
//   - https://github.com/webdevfuel/go-htmx-toast-notifications/tree/08-trigger-from-backend
//     https://www.youtube.com/watch?v=Id6ZkOqaqno

type ToastType = 'info' | 'warning';

type Toast = {
    id: string;
    message: string;
    type: ToastType;
    show: boolean;
};

export class ToastHandler {
    toasts: Toast[] = [];

    add(event: CustomEvent) {
        debugger;
        this.toasts.push({
            id: `toast-${Math.random().toString(16).slice(2)}`,
            message: event.detail.message,
            type: event.detail.type,
            show: false
        });
    }

    show(id: string) {
        const toast = this.toasts.find((toast) => toast.id === id);
        const index = this.toasts.findIndex((toast) => toast.id === id);
        this.toasts.splice(index, 1, { ...toast, show: true });
    }

    remove(id: string) {
        const toast = this.toasts.find((toast) => toast.id === id);
        const index = this.toasts.findIndex((toast) => toast.id === id);
        this.toasts.splice(index, 1, { ...toast, show: false });
    }

    dismiss(id: string) {
        let that = this;
        setTimeout(function () {
            that.remove(id);
        }, 50);
    }

    toastInit(el: HTMLElement) {
        const id = el.getAttribute('id');
        let that = this;
        // enter
        setTimeout(function () {
            that.show(id);
        }, 50);
        // leave
        setTimeout(function () {
            that.remove(id);
        }, 4000);
    }

    globalInit() {
        window.toast = function (message, type = 'info') {
            window.dispatchEvent(
                new CustomEvent('add-toast', {
                    detail: {
                        message: message,
                        type: type
                    }
                })
            );
        };
    }
}
